import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Special offers',
  view_more: 'View more',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Deal',
    'FREE ITEM': 'Free item',
    REWARDS: 'Rewards',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Extra Points',
      description: 'Rate us on Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Special deal',
      description: 'Already automatically applied',
    },
    buttons: {
      add: 'Add',
      remove: 'Remove',
      show_details: 'Show details',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} App Sign-Up Bonus',
      desc: 'Get {{amount}} cashback when you log in on our app.',
    },
    welcome_bonus: {
      title: '{{amount}} Welcome Bonus',
      desc: 'Get {{amount}} cashback when you register.',
    },
  },
  discounts: {
    title: '{{discount}} discount',
    usage_threshold: '(Min: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} discount off on your next order - code: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: '{{discount}} discount on your next {{count}} orders - code: {{code}}',
    },
  },
  feedback: {
    login:
      "<highlight>Log in</highlight> to use this promo so we can make sure you haven't used it yet. Login and try again.",
  },
};
